import React from "react";

import Select from "../index";

export default function Invoice(props) {
  const items = [
    "AUTHORISED",
    "DELETED",
    "DRAFT",
    "PAID",
    "SENT",
    "SUBMITTED",
    "VOIDED",
  ];

  return <Select name="status" items={items} {...props} />;
}
